'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactAddonsUpdate = require('react-addons-update');

var _reactAddonsUpdate2 = _interopRequireDefault(_reactAddonsUpdate);

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var _lodash = require('lodash.groupby');

var _lodash2 = _interopRequireDefault(_lodash);

var _lodash3 = require('lodash.isempty');

var _lodash4 = _interopRequireDefault(_lodash3);

var _lodash5 = require('lodash.uniq');

var _lodash6 = _interopRequireDefault(_lodash5);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APITimeFormat = 'YYYY-MM-DD HH:mm:ss.000000';

var DatesBox = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(DatesBox, _Component);

  function DatesBox() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, DatesBox);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DatesBox.__proto__ || (0, _getPrototypeOf2.default)(DatesBox)).call.apply(_ref, [this].concat(args))), _this), _this.state = _this.fetchInitialState(), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(DatesBox, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // Setup Kalendae translations
      var currentLocale = this.props.polyglot.currentLocale;

      var kalendaeTranslations = require('../../locales/' + currentLocale + '/calendar');
      window.Kalendae.moment.locale(currentLocale, kalendaeTranslations);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.startDate !== this.props.startDate) {
        this.setState({ startDate: nextProps.startDate });
      }
      if (nextProps.endDate !== this.props.endDate) {
        this.setState({ endDate: nextProps.endDate });
      }
      if (nextProps.dates !== this.props.dates) {
        this.setState({
          dates: nextProps.dates.length ? (0, _lodash2.default)(nextProps.dates, function (date) {
            return date.start_date.substring(0, 10);
          }) : {}
        });
      }
      if (nextProps.recurring !== this.props.recurring) {
        this.setState({ recurring: nextProps.recurring });
      }

      this.initEventDates(nextProps.startDate, nextProps.dates);
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      // Enable/Disable the save button.
      this.toggleSaveButton(nextState);
    }
  }, {
    key: 'setActiveCalendarDate',
    value: function setActiveCalendarDate(date) {
      var selectedDate = date !== undefined ? date : this.state.selectedDate;

      window.jQuery('.k-days span').removeAttr('id');
      if (selectedDate && selectedDate.isValid()) {
        setTimeout(function () {
          window.jQuery('.k-days span[data-date=' + selectedDate.format('YYYY-MM-DD') + ']').attr('id', 'k-editing-mode');
        });
      }
    }
  }, {
    key: 'getTranslatedItem',
    value: function getTranslatedItem(item, duration) {
      return {
        start_date: item ? item.format(APITimeFormat) : null,
        duration: duration,
        error: false
      };
    }
  }, {
    key: 'toggleSaveButton',
    value: function toggleSaveButton(nextState) {
      if (this.refs.saveButton) {
        if ((0, _lodash4.default)(nextState.selectedDates)) {
          this.refs.saveButton.setAttribute('disabled', '');
        } else {
          this.refs.saveButton.removeAttribute('disabled');
        }
      }
    }
  }, {
    key: 'fetchInitialState',
    value: function fetchInitialState() {
      var selectedDates = (0, _lodash6.default)(this.props.dates.map(function (date) {
        return window.Kalendae.moment(date.start_date).format('YYYY-MM-DD');
      }), true);

      return {
        kalendae: null,
        selectionMode: selectedDates.length > 1 ? 'multiple' : 'single',
        startDate: this.props.startDate,
        dates: this.props.dates.length ? (0, _lodash2.default)(this.props.dates, function (date) {
          return date.start_date.substring(0, 10);
        }) : {},
        selectedDate: this.props.startDate ? window.Kalendae.moment(this.props.startDate) : false,
        selectedDates: selectedDates,
        timePanel: false,
        multiple: false
      };
    }
  }, {
    key: 'initEventDates',
    value: function initEventDates(startDate, dates) {
      var _this2 = this;

      this.setState({
        startDate: startDate,
        selectedDate: startDate ? window.Kalendae.moment(startDate) : false,
        selectedDates: dates ? (0, _lodash6.default)(dates.map(function (date) {
          return window.Kalendae.moment(date.start_date).format('YYYY-MM-DD');
        }), true) : []
      }, function () {
        if (_this2.state.selectedDates.length > 1) {
          _this2.setState({
            selectionMode: 'multiple'
          });
        }
      });
    }
  }, {
    key: 'loadCalendar',
    value: function loadCalendar() {
      var datesBox = this;
      var selected = this.state.selectedDates.length ? this.state.selectedDates : this.state.selectedDate;

      if (this.state.selectionMode === 'range') {
        selected = [selected.shift(), selected.pop()];
      }

      this.setState({
        kalendae: new window.Kalendae(_reactDom2.default.findDOMNode(this.refs.kalendae), {
          mode: this.state.selectionMode,
          selected: selected,
          weekStart: 1,
          subscribe: {
            change: function dateChanged(date) {
              var startDate = this.getSelected() ? date.format(APITimeFormat) : false;
              var currentDate = date.format('YYYY-MM-DD');

              if (datesBox.state.selectionMode === 'single') {
                var selectedDate = datesBox.state.dates[currentDate];
                var newDates = {};

                newDates[currentDate] = selectedDate || [DatesBox.buildNewDate()];

                datesBox.setState({
                  startDate: startDate,
                  dates: newDates,
                  selectedDates: [currentDate]
                });
              } else {
                if (startDate) {
                  startDate = this.getSelectedAsDates()[0];
                }

                var selectedDates = this.getSelectedAsText();

                if (datesBox.state.selectionMode === 'range' && selectedDates.length > 1) {
                  var datesRaw = this.getSelectedRaw();
                  var datesInRange = [];
                  for (var idx = datesRaw[0]; idx <= datesRaw[1]; idx.add(1, 'day')) {
                    datesInRange.push(idx.format('YYYY-MM-DD'));
                  }
                  selectedDates = datesInRange;
                }

                var _newDates = datesBox.state.dates;

                selectedDates.forEach(function (selectedDate) {
                  if (!(selectedDate in _newDates)) {
                    _newDates[selectedDate] = [DatesBox.buildNewDate()];
                  }
                });

                datesBox.setState({
                  startDate: startDate ? window.Kalendae.moment(startDate).format('YYYY-MM-DD') : false,
                  selectedDates: selectedDates,
                  dates: _newDates
                });
              }
            },
            'date-clicked': function dateClicked(date) {
              datesBox.setState({
                selectedDate: date
              }, function () {
                datesBox.setActiveCalendarDate(date);
              });

              // Don't allow multiple date toggle.
              if (this.isSelected(date) && datesBox.state.selectionMode !== 'single') {
                return false;
              }
            },
            'view-changed': function viewChanged() {
              datesBox.setActiveCalendarDate();
            }
          }
        })
      }, this.setActiveCalendarDate);
    }
  }, {
    key: 'unloadCalendar',
    value: function unloadCalendar() {
      this.setState(this.fetchInitialState());
    }
  }, {
    key: 'updateCalendar',
    value: function updateCalendar(event) {
      var _this3 = this;

      this.setState({
        selectionMode: event.target.value,
        dates: {},
        startDate: false,
        selectedDate: false,
        selectedDates: []
      }, function () {
        _this3.setActiveCalendarDate(false);
        _this3.state.kalendae.setSelected(false);
        _this3.state.kalendae.settings.mode = _this3.state.selectionMode;
      });
    }
  }, {
    key: 'removeDate',
    value: function removeDate(selectedDate) {
      this.state.kalendae.removeSelected(selectedDate);

      delete this.state.dates[selectedDate];

      var index = this.state.selectedDates.indexOf(selectedDate);

      this.setState({
        selectedDates: (0, _reactAddonsUpdate2.default)(this.state.selectedDates, { $splice: [[index, 1]] })
      });

      if (index !== -1 && this.state.selectedDates.length) {
        this.setState({
          startDate: this.state.selectedDates[0]
        });
      } else {
        this.setState({
          startDate: false
        });
      }

      this.setState({
        selectedDate: false
      }, this.setActiveCalendarDate);
    }
  }, {
    key: 'updateTime',
    value: function updateTime(item, duration, index, key) {
      var _this4 = this;

      var translatedItem = this.getTranslatedItem(item, duration);

      if (!(key in this.state.dates)) {
        this.setState({
          dates: (0, _reactAddonsUpdate2.default)(this.state.dates, { $merge: (0, _defineProperty3.default)({}, key, []) })
        }, function () {
          _this4.addDateToArray(translatedItem, index, key);
        });
      } else {
        this.addDateToArray(translatedItem, index, key);
      }
    }
  }, {
    key: 'addDateToArray',
    value: function addDateToArray(translatedItem, index, key) {
      var newDates = void 0;
      if (index >= 0 && index in this.state.dates[key]) {
        newDates = (0, _reactAddonsUpdate2.default)(this.state.dates, (0, _defineProperty3.default)({}, key, (0, _defineProperty3.default)({}, index, { $set: translatedItem })));
      } else {
        newDates = (0, _reactAddonsUpdate2.default)(this.state.dates, (0, _defineProperty3.default)({}, key, { $push: [translatedItem] }));
      }

      this.setState({
        dates: newDates
      });
    }
  }, {
    key: 'addTimeRow',
    value: function addTimeRow(selectedDate) {
      var date = selectedDate.format('YYYY-MM-DD');
      this.setState({
        dates: (0, _reactAddonsUpdate2.default)(this.state.dates, (0, _defineProperty3.default)({}, date, { $push: [DatesBox.buildNewDate()] }))
      });
    }
  }, {
    key: 'removeTime',
    value: function removeTime(selectedDate, index) {
      var date = selectedDate.format('YYYY-MM-DD');
      if (this.state.dates[date].length > 1) {
        this.setState({
          dates: (0, _reactAddonsUpdate2.default)(this.state.dates, (0, _defineProperty3.default)({}, date, { $splice: [[index, 1]] }))
        });
      } else {
        this.setState({
          dates: (0, _reactAddonsUpdate2.default)(this.state.dates, (0, _defineProperty3.default)({}, date, { $set: [DatesBox.buildNewDate()] }))
        });
      }
    }
  }, {
    key: 'currentSelectedDate',
    value: function currentSelectedDate() {
      if (this.state.selectedDate) {
        return this.state.selectedDate.format('YYYY-MM-DD');
      }
      return false;
    }
  }, {
    key: 'applyTimesWithRule',
    value: function applyTimesWithRule(selectedDate, rule) {
      var _this5 = this;

      var newDates = {};

      this.state.dates[selectedDate.format('YYYY-MM-DD')].forEach(function (item) {
        var time = window.Kalendae.moment(item.start_date);
        _this5.state.selectedDates.filter(rule).forEach(function (date) {
          var newDate = window.Kalendae.moment(date + ' ' + time.format('HH:mm'));
          if (!(date in newDates)) {
            newDates[date] = [];
          }
          newDates[date].push(_this5.getTranslatedItem(newDate, item.duration));
        });
      });

      this.setState({
        dates: (0, _reactAddonsUpdate2.default)(this.state.dates, { $merge: newDates })
      });
    }
  }, {
    key: 'applyToAllDates',
    value: function applyToAllDates(selectedDate) {
      this.applyTimesWithRule(selectedDate, function (date) {
        return window.Kalendae.moment(date) !== window.Kalendae.moment(selectedDate);
      });
    }
  }, {
    key: 'applyToWeekDays',
    value: function applyToWeekDays(selectedDate) {
      this.applyTimesWithRule(selectedDate, function (date) {
        return window.Kalendae.moment(date).weekday() === window.Kalendae.moment(selectedDate).weekday();
      });
    }
  }, {
    key: 'otherDates',
    value: function otherDates() {
      var polyglot = this.props.polyglot;

      var otherDatesCount = this.state.selectedDates.length - 1;
      var otherDates = '';

      if (otherDatesCount >= 1) {
        var otherDatesString = polyglot.t('events.form.calendar.otherDates', otherDatesCount);

        otherDates = _react2.default.createElement(
          'strong',
          { className: 'info-text other-dates' },
          _react2.default.createElement('span', { className: 'icon-cg-multiple' }),
          otherDatesString
        );
      }

      return otherDates;
    }
  }, {
    key: 'hideCalendarPopup',
    value: function hideCalendarPopup() {
      this.refs.calendarPopover.hide();
    }
  }, {
    key: 'handleCancel',
    value: function handleCancel() {
      this.hideCalendarPopup();
    }
  }, {
    key: 'returnToDates',
    value: function returnToDates() {
      var _this6 = this;

      this.setState({
        timePanel: false
      }, function () {
        _this6.loadCalendar();
      });
    }
  }, {
    key: 'chooseTime',
    value: function chooseTime() {
      this.setState({
        timePanel: true
      });
    }
  }, {
    key: 'toggleMultipleTimes',
    value: function toggleMultipleTimes(evt) {
      this.setState({
        multiple: !!evt.target.checked
      });
    }
  }, {
    key: 'handleOK',
    value: function handleOK() {
      var _props = this.props,
          onChange = _props.onChange,
          defaultVenue = _props.defaultVenue,
          defaultRoom = _props.defaultRoom;
      var dates = this.state.dates;


      var hasError = false;
      var datesArray = (0, _keys2.default)(dates).reduce(function (acc, day) {
        dates[day].map(function (date) {
          if (!date.start_date) {
            hasError = true;
            date.error = true;
          } else {
            var venue = date.venue,
                room = date.room;

            acc.push({
              start_date: date.start_date,
              duration: date.duration,
              venue: venue || defaultVenue,
              room: room || defaultRoom
            });
          }
        });
        return acc;
      }, []);

      if (!hasError) {
        onChange(this.state.startDate, this.state.endDate, null, datesArray);

        this.hideCalendarPopup();
      }

      this.setState({
        dates: dates
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var _props2 = this.props,
          popoverContainer = _props2.popoverContainer,
          errors = _props2.errors,
          polyglot = _props2.polyglot;
      var _state = this.state,
          selectedDates = _state.selectedDates,
          selectionMode = _state.selectionMode,
          startDate = _state.startDate,
          dates = _state.dates,
          timePanel = _state.timePanel,
          multiple = _state.multiple;

      var popover = timePanel ? _react2.default.createElement(
        _reactBootstrap.Popover,
        { id: 'dates-popover', className: 'dates-box-popover' },
        _react2.default.createElement(
          'div',
          { className: 'dates-box-popover-time-header' },
          _react2.default.createElement(
            'a',
            { onClick: this.returnToDates.bind(this), className: 'back-link', href: '#' },
            _react2.default.createElement('span', { className: 'icon-cg-chevron-left' }),
            ' ',
            polyglot.t('events.form.calendar.backToDates')
          ),
          _react2.default.createElement(
            'label',
            { className: 'toggle-multiple-times' },
            _react2.default.createElement('input', { type: 'checkbox', onChange: this.toggleMultipleTimes.bind(this), checked: multiple }),
            polyglot.t('events.form.calendar.toggleMultipleTimes')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row dates-outer-time-container' },
          _react2.default.createElement(
            'div',
            { key: 'timeList', className: 'col-sm-12' },
            _react2.default.createElement(
              'div',
              { className: 'dates-list-container-time' },
              selectedDates.map(function (date, index) {
                return _react2.default.createElement(
                  'div',
                  { key: index, className: 'result times-list-item' },
                  _react2.default.createElement('a', { onClick: _this7.removeDate.bind(_this7, date), className: 'result-delete' }),
                  _react2.default.createElement(
                    'div',
                    { className: 'times-list-item-dates' },
                    _react2.default.createElement(
                      'strong',
                      null,
                      (0, _moment2.default)(date).format('LLLL')
                    )
                  ),
                  dates[date].map(function (time, ind) {
                    return _react2.default.createElement(_components.TimeListItem, {
                      key: ind,
                      index: ind,
                      item: time,
                      selectedDate: (0, _moment2.default)(date),
                      updateTime: _this7.updateTime.bind(_this7),
                      removeTime: _this7.removeTime.bind(_this7),
                      multipleTimes: multiple,
                      multipleDates: selectedDates.length > 1,
                      addTimeRow: _this7.addTimeRow.bind(_this7),
                      applyToAllDates: _this7.applyToAllDates.bind(_this7),
                      last: ind === dates[date].length - 1,
                      polyglot: polyglot
                    });
                  })
                );
              })
            ),
            _react2.default.createElement(
              'div',
              { className: 'form-actions text-right' },
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  onClick: this.handleCancel.bind(this),
                  className: 'btn btn-default btn-cancel'
                },
                polyglot.t('events.form.calendar.cancel')
              ),
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  ref: 'saveButton',
                  onClick: this.handleOK.bind(this),
                  className: 'btn btn-primary'
                },
                polyglot.t('events.form.calendar.save')
              )
            )
          )
        )
      ) : _react2.default.createElement(
        _reactBootstrap.Popover,
        { id: 'dates-popover', className: 'dates-box-popover' },
        _react2.default.createElement(
          'div',
          { className: 'dates-box-popover-header' },
          polyglot.t('events.form.calendar.chooseMode'),
          _react2.default.createElement(
            'label',
            { className: 'select-wrapper' },
            _react2.default.createElement(
              'select',
              {
                name: 'frequency',
                className: 'form-control',
                onChange: this.updateCalendar.bind(this),
                value: this.state.selectionMode
              },
              _react2.default.createElement(
                'option',
                { value: 'single' },
                polyglot.t('events.form.calendar.modeSingle')
              ),
              _react2.default.createElement(
                'option',
                { value: 'multiple' },
                polyglot.t('events.form.calendar.modeMultiple')
              ),
              _react2.default.createElement(
                'option',
                { value: 'range' },
                polyglot.t('events.form.calendar.modeRange')
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'row dates-outer-container' },
          _react2.default.createElement(
            'div',
            { className: 'col-sm-6' },
            _react2.default.createElement('div', {
              ref: 'kalendae',
              id: 'kalendae',
              className: 'auto-kal',
              'data-kal': 'mode: \'' + selectionMode + '\''
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'col-sm-6' },
            !(0, _lodash4.default)(selectedDates) ? _react2.default.createElement(
              'div',
              { className: 'dates-list-container' },
              _react2.default.createElement(
                'div',
                { className: 'dates-list-item' },
                _react2.default.createElement(
                  'div',
                  { className: 'date-details' },
                  _react2.default.createElement(
                    'span',
                    { className: 'date-details-help' },
                    polyglot.t('events.form.calendar.selectedDate', selectedDates.length)
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'date-time' },
                selectedDates.map(function (item, index) {
                  return _react2.default.createElement(
                    'div',
                    { key: index, className: 'result times-list-item' },
                    _react2.default.createElement(
                      'div',
                      { className: 'times-list-item-dates' },
                      _react2.default.createElement(
                        'strong',
                        null,
                        (0, _moment2.default)(item).format('LLLL')
                      )
                    ),
                    _react2.default.createElement('a', { onClick: _this7.removeDate.bind(_this7, item), className: 'result-delete' })
                  );
                })
              )
            ) : _react2.default.createElement(_components.DateListEmpty, { polyglot: polyglot }),
            _react2.default.createElement(
              'div',
              { className: 'form-actions text-right' },
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  onClick: this.handleCancel.bind(this),
                  className: 'btn btn-default btn-cancel'
                },
                polyglot.t('events.form.calendar.cancel')
              ),
              _react2.default.createElement(
                'button',
                {
                  type: 'button',
                  ref: 'saveButton',
                  onClick: this.chooseTime.bind(this),
                  className: 'btn btn-primary'
                },
                polyglot.t('events.form.calendar.selectHours')
              )
            )
          )
        )
      );

      var datesBoxData = startDate ? _react2.default.createElement(_components.CalendarFilled, {
        date: startDate,
        dates: dates,
        otherDates: this.otherDates(),
        polyglot: polyglot,
        errors: errors
      }) : _react2.default.createElement(_components.CalendarEmpty, { polyglot: polyglot, errors: errors });

      return _react2.default.createElement(
        _reactBootstrap.OverlayTrigger,
        {
          ref: 'calendarPopover',
          placement: 'bottom',
          trigger: ['click', 'focus'],
          delayShow: 200,
          onEnter: this.loadCalendar.bind(this),
          onExit: this.unloadCalendar.bind(this),
          rootClose: true,
          container: popoverContainer,
          overlay: popover
        },
        datesBoxData
      );
    }
  }], [{
    key: 'buildNewDate',
    value: function buildNewDate() {
      return { start_date: null, duration: null, error: false };
    }
  }]);
  return DatesBox;
}(_react.Component), _class.propTypes = {
  dates: _propTypes2.default.array,
  defaultVenue: _propTypes2.default.object,
  defaultRoom: _propTypes2.default.object,
  endDate: _propTypes2.default.string,
  errors: _propTypes2.default.array.isRequired,
  onChange: _propTypes2.default.func,
  polyglot: _propTypes2.default.object.isRequired,
  popoverContainer: _propTypes2.default.any,
  recurring: _propTypes2.default.any,
  startDate: _propTypes2.default.string
}, _temp2);
exports.default = DatesBox;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Form/DatesBox.js
// module id = 2205
// module chunks = 0